module.exports = __webpack_public_path__ + "static/media/C.7984f1f9.svg";